<script lang="ts" setup>
import type { StaticPageImage } from '~/types/StaticPageList';

const props = defineProps<{ image: StaticPageImage }>();

const computedImageAlt = computed(() => {
  return props.image.properties?.alt || props.image.properties?.title || '';
});
</script>

<template>
  <div class="constructor-image">
    <p
      v-if="image.properties?.title"
      class="constructor-image__title"
    >
      {{ image.properties?.title }}
    </p>

    <div class="constructor-image__image-wrap">
      <AppLink
        v-if="image.properties?.link"
        :title="image.properties?.title ?? ''"
        :to="image.properties?.link"
        class="constructor-image__image-link"
      />

      <picture v-if="image.url">
        <source
          :srcset="`${image.conversions_webp.thumb_390}, ${image.conversions_webp.thumb_780} 2x`"
          media="(max-width: 640px)"
          type="image/webp"
        />

        <source
          :srcset="`${image.conversions_webp.thumb_780}, ${image.conversions_webp.thumb_1560} 2x`"
          type="image/webp"
        />

        <source
          :srcset="image.conversions.thumb_390"
          type="image/jpeg"
        />

        <img
          :alt="computedImageAlt"
          :src="image.url"
          class="constructor-image__image"
          loading="lazy"
        />
      </picture>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.constructor-image {
  width: 100%;

  &__title {
    margin-bottom: 12px;
    color: $hell-black;
    font-weight: $bold;
  }

  &__image-wrap {
    position: relative;
    z-index: 1;
  }

  &__image-link {
    @include image-link;

    border-radius: 12px;
  }

  &__image {
    object-fit: contain;
    overflow: hidden;
    width: 100%;
    height: auto;
    border-radius: 12px;
    aspect-ratio: 16/9;
  }
}
</style>
